import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalContent } from 'semantic-ui-react';
import { Document, Page, pdfjs } from 'react-pdf';
import './index.css';
import {
  segimobConfirmTerm
} from '../../../../services/fire-insurance-budget';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

interface SegimobTermModalProps {
  open: boolean;
  estateId: string;
  segimobCode: string;
  pdfData: string;
  onClose: () => void;
  onTermAccepted?: (estate: { id: string; segimob_term: boolean }) => void;
}

const SegimobTermModal = (props: SegimobTermModalProps) => {
  const { open, estateId, segimobCode, pdfData, onClose, onTermAccepted } = props;
  const [numPages, setNumPages] = useState<number | null>(null);
  const [base64Pdf, setBase64Pdf] = useState<string>('');
  const [isSending, setIsSending] = useState<boolean>(false);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
  }

  const handleDownload = () => {
    if (!base64Pdf) return;
    const link = document.createElement('a');
    link.href = base64Pdf;
    link.download = 'termo.pdf';
    link.click();
    URL.revokeObjectURL(link.href);
  };

  const handleAcceptedTerm = async () => {
    setIsSending(true);
    try {
      const response = await segimobConfirmTerm(estateId);
      if (response && response.success && response.estate) {
        // Chama callback para atualizar Redux
        if (onTermAccepted) {
          onTermAccepted({
            id: response.estate.id,
            segimob_term: response.estate.segimobTerm
          });
        } else {
          // Fallback: recarrega página se não houver callback
          window.location.reload();
        }
      }
    } catch (error) {
      // Erro silencioso - não exibe mensagem
    } finally {
      setIsSending(false);
    }
  };

  useEffect(() => {
    if (open && pdfData) {
      // Converte base64 para blob URL
      try {
        const byteCharacters = atob(pdfData);
        const byteNumbers = new Array(byteCharacters.length)
          .fill(0)
          .map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        setBase64Pdf(blobUrl);

        return () => URL.revokeObjectURL(blobUrl);
      } catch (error) {
        // Se falhar ao processar PDF, fecha modal
        onClose();
      }
    }
  }, [open, pdfData, onClose]);

  return (
    <Modal
      closeOnEscape={false}
      closeOnDimmerClick={true}
      open={open}
      onClose={onClose}
      size="large"
    >
      <ModalContent scrolling>
        {base64Pdf && (
          <Document file={base64Pdf} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                scale={1.5} // aumenta a resolução
                renderTextLayer={false}
                renderAnnotationLayer={false}
                className="pdf-page"
              />
            ))}
          </Document>
        )}
      </ModalContent>
      {base64Pdf && (
        <Modal.Actions>
          <Button onClick={onClose}>
            Fechar
          </Button>
          <Button icon onClick={handleDownload}>
            Download
          </Button>
          <Button icon color="green" onClick={handleAcceptedTerm} disabled={isSending}>
            Li e Aceito o termo
          </Button>
        </Modal.Actions>
      )}
    </Modal>
  );
};

export default SegimobTermModal;
